import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import DayJsUtils from '@date-io/dayjs';
import {
  MuiPickersUtilsProvider,
  DateTimePicker as MuiDateTimePicker,
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  formControl: { display: 'flex', marginBottom: '0.5rem', marginTop: 0 },
  input: { color: 'white', width: '100%' },
  button: { color: 'white' },
}));

const DateTimePicker = ({
  onChange,
  value,
  label,
  className,
  minDate,
  required,
  error,
}) => {
  const classes = useStyles();
  return (
    <MuiPickersUtilsProvider utils={DayJsUtils}>
      <MuiDateTimePicker
        shrink
        required={required}
        className={cn(classes.formControl, className)}
        initialFocusedDate={minDate && minDate}
        variant="inline"
        format="DD-MMM-YYYY HH:mm"
        minDate={minDate}
        id={label}
        label={label}
        value={value ? value : null}
        onChange={onChange}
        inputProps={{
          className: classes.input,
        }}
        error={error}
        helperText={error ? error : null}
      />
    </MuiPickersUtilsProvider>
  );
};

DateTimePicker.propTypes = {
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  value: PropTypes.instanceOf(Date),
  label: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default DateTimePicker;
